import { render, staticRenderFns } from "./ReadingDefinitionModal.vue?vue&type=template&id=d8b164c4&"
import script from "./ReadingDefinitionModal.vue?vue&type=script&lang=ts&"
export * from "./ReadingDefinitionModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingDefinitionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports